import { CustomValidators } from 'shared/validation/custom-validators';
import { countryLookup } from 'utils/lookups';
import patterns from 'utils/patterns';
import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';


/* eslint-disable */
export const digitalAssetsSegmentData: any = [
  {
    'field_map': 'filename',
    'item_name': 'filename',
    'title': 'File name',
    'hint_detail': 'File name of digital asset as uploaded into system.',
    'hint_panel' : 'File name (including file extension) of digital asset.',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5': {
        minLength: 1,
        maxLength: 80,
        pattern: patterns.filename,
        message: 'Filename must be no more than 80 characters. No special characters allowed: \/:*"\'<>|#%',
      }
    }
  },
  {
    'field_map': 'uri',
    'item_name': 'uri',
    'title': 'URL',
    'hint_detail': 'File url for this digital asset.',
    'hint_panel' : 'Enter the URL for this digital asset. Must include "http://" or "https://"',
    'example': 'http://www.url.com/file.jpg',
    'sequence': 2,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5': {
        validator: CustomValidators.url,
        maxLength: 2000,
        message: 'URL must be less than 2000 characters and begin with http://',
      }
    }
  },
  {
    'field_map': 'width',
    'item_name': 'width',
    'title': 'Asset width',
    'hint_detail': 'Horizontal measurement of digital asset file.',
    'hint_panel' : 'Horizontal measurement of digital asset file.',
    'example': '',
    'sequence': 3,
    'show_more': true,
    'lookup': null,
    'imageOnly': true,
  },
  {
    'field_map': 'height',
    'item_name': 'height',
    'title': 'Asset height',
    'hint_detail': 'Vertical measurement of digital asset file.',
    'hint_panel' : 'Vertical measurement of digital asset file.',
    'example': '',
    'sequence': 4,
    'show_more': true,
    'lookup': null,
    'imageOnly': true,
  },
  {
    'field_map': 'uom',
    'item_name': 'uom',
    'title': 'Unit of measurement',
    'hint_detail': 'Identifies pixels, inches or other measurement units for use with various Asset Types',
    'hint_panel' : 'Identifies pixels, inches or other measurement units for use with various Asset Types',
    'example': '',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      {
        'option': 'px',
        'title': 'Pixels'
      },
      {
        'option': 'in',
        'title': 'Inches'
      },
      {
        'option': 'cm',
        'title': 'Centimeters'
      }
    ],
    'imageOnly': true,
  },
  {
    'field_map': 'resolution',
    'item_name': 'resolution',
    'title': 'Resolution',
    'hint_detail': 'DPI (dots per inch) of digital asset',
    'hint_panel' : 'DPI (dots per inch) of digital asset',
    'example': '',
    'sequence': 6,
    'show_more': true,
    'lookup': [
      {
        "option": 72,
        "title": '72 dpi'
      },
      {
        "option": 96,
        "title": '96 dpi'
      },
      {
        "option": 300,
        "title": '300 dpi'
      },
      {
        "option": 600,
        "title": '600 dpi'
      },
      {
        "option": 800,
        "title": '800 dpi'
      },
      {
        "option": 1200,
        "title": '1200 dpi'
      }
    ],
    'imageOnly': true,
  },
  {
    'field_map': 'colorMode',
    'item_name': 'color_mode',
    'title': 'Color mode',
    'hint_detail': 'Digital asset color mode',
    'hint_panel' : 'Digital asset color mode',
    'example': '',
    'sequence': 7,
    'show_more': true,
    'lookup': [
      { 'option': 'RGB', 'title': 'RGB' },
      { 'option': 'CMY', 'title': 'CMYK' },
      { 'option': 'GRA', 'title': 'Gray Scale' },
      { 'option': 'OTH', 'title': 'Other' },
      { 'option': 'WEB', 'title': 'Vector B/W' },
      { 'option': 'VEC', 'title': 'Vector Color' },
      { 'option': 'BIT', 'title': 'Bitmap' }
    ],
    'imageOnly': true,
  },
  {
    'field_map': 'description',
    'item_name': 'description',
    'title': 'File description',
    'hint_detail': 'General description for the use of the digital asset.',
    'hint_panel' : 'Enter up to 80 characters for a general description of use of the digital asset.',
    'example': 'For use on websites, brochures, and mailers.',
    'sequence': 8,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5': {
        maxLength: 80,
        message: 'File description must be no more than 80 characters',
      }
    }
  },
  {
    'field_map': 'background',
    'item_name': 'background',
    'title': 'Background',
    'hint_detail': 'Indicates what type of background is in the photo.',
    'hint_panel' : 'Select what type of background is in the photo.',
    'example': '',
    'sequence': 9,
    'show_more': true,
    'lookup': [
      {
        'option': 'WHI',
        'title': 'White'
      },
      {
        'option': 'CLI',
        'title': 'White w/clipping path'
      },
      {
        'option': 'TRA',
        'title': 'Transparent'
      },
      {
        'option': 'OTH',
        'title': 'Other'
      }
    ],
    'imageOnly': true,
  },
  {
    'field_map': 'orientationView',
    'item_name': 'orientation_view',
    'title': 'Orientation view',
    'hint_detail': 'Indicates the angle or orientation of the photo. User-defined orientations are maintained at Global account level.',
    'hint_panel' : 'Select the angle or orientation of this photo. User-defined orientations are maintained at Global account level.',
    'example': '',
    'sequence': 10,
    'show_more': true,
    'lookup': [
      {
        'option': 'ANG',
        'title': 'Angle'
      },
      {
        'option': 'BAC',
        'title': 'Back'
      },
      {
        'option': 'BOT',
        'title': 'Bottom'
      },
      {
        'option': 'CON',
        'title': 'Connector'
      },
      {
        'option': 'FRO',
        'title': 'Front'
      },
      {
        'option': 'KIT',
        'title': 'Kit'
      },
      {
        'option': 'LEF',
        'title': 'Left'
      },
      {
        'option': 'LIF',
        'title': 'Lifestyle'
      },
      {
        'option': 'NUL',
        'title': 'Not applicable'
      },
      {
        'option': 'OTH',
        'title': 'Other'
      },
      {
        'option': 'RIT',
        'title': 'Right'
      },
      {
        'option': 'SID',
        'title': 'Side'
      },
      {
        'option': 'TOP',
        'title': 'Top'
      },
      {
        'option': 'ZZ1',
        'title': 'User 1'
      },
      {
        'option': 'ZZ2',
        'title': 'User 2'
      },
      {
        'option': 'ZZ3',
        'title': 'User 3'
      },
      {
        'option': 'ZZ4',
        'title': 'User 4'
      },
      {
        'option': 'ZZ5',
        'title': 'User 5'
      },
      {
        'option': 'ZZ6',
        'title': 'User 6'
      },
      {
        'option': 'ZZ7',
        'title': 'User 7'
      },
      {
        'option': 'ZZ8',
        'title': 'User 8'
      },
      {
        'option': 'ZZ9',
        'title': 'User 9'
      }
    ],
    'imageOnly': true,
  },
  {
    'field_map': 'effectiveDate',
    'item_name': 'effective_date',
    'title': 'Effective date',
    'hint_detail': 'Date for when this digital asset is in effect.',
    'hint_panel' : 'Enter date for when this digital asset is in effect.',
    'example': '01/01/2017',
    'sequence': 11,
    'show_more': true,
    'lookup': null,
    'type': DetailsControlType.Date,
    'validation': {
      'PIES_6_5': {
        message: 'Effective date cannot be set ahead of Expiration date.',
      }
    }
  },
  {
    'field_map': 'expirationDate',
    'item_name': 'expiration_date',
    'title': 'Expiration date',
    'hint_detail': 'Date for when this digiital asset should no longer be used.',
    'hint_panel' : 'Enter date for when this digiital asset should no longer be used. Expiration dates are not commonly used.',
    'example': '01/01/2017',
    'sequence': 12,
    'show_more': true,
    'lookup': null,
    'type': DetailsControlType.Date,
  },
  {
    'field_map': 'country',
    'item_name': 'country',
    'title': 'Country',
    'hint_detail': 'Country',
    'hint_panel' : 'Country',
    'example': '',
    'sequence': 13,
    'show_more': true,
    'lookup': countryLookup,
  },
  {
    'field_map': 'language',
    'item_name': 'language',
    'title': 'Language',
    'hint_detail': 'Language',
    'hint_panel' : '',
    'example': '',
    'sequence': 14,
    'show_more': true,
     'lookup': [
      {
        'option': 'EN',
        'title': 'English'
      },
      {
        'option': 'ES',
        'title': 'Spanish'
      },
      {
        'option': 'FR',
        'title': 'French'
      }
    ]
  },
  {
    'field_map': 'additionalInfo',
    'item_name': 'additional_info',
    'title': 'Additional information',
    'hint_detail': 'Additional information',
    'hint_panel' : 'Additional information',
    'example': '',
    'sequence': 15,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5': {
        maxLength: 48,
        message: 'Additional information must be no more than 48 characters',
      }
    }
  },
  {
    'field_map': 'fileType',
    'item_name': 'file_type',
    'title': 'File type',
    'hint_detail': 'File type of the digital asset uploaded into the system.',
    'hint_panel' : 'File type of the digital asset uploaded into the system.',
    'example': '',
    'sequence': 16,
    'show_more': true,
    'lookup': [
      { 'option': 'TIF', 'title': 'TIF' },
      { 'option': 'JPG', 'title': 'JPG' },
      { 'option': 'EPS', 'title': 'EPS' },
      { 'option': 'TXT', 'title': 'TXT' },
      { 'option': 'FLV', 'title': 'FLV' },
      { 'option': 'F4V', 'title': 'F4V' },
      { 'option': 'AVI', 'title': 'AVI' },
      { 'option': 'WEBM', 'title': 'WEBM' },
      { 'option': 'OGV', 'title': 'OGV' },
      { 'option': 'MP4', 'title': 'MP4' },
      { 'option': 'MKV', 'title': 'MKV' },
      { 'option': 'AIF', 'title': 'AIF' },
      { 'option': 'WAV', 'title': 'WAV' },
      { 'option': 'WMA', 'title': 'WMA' },
      { 'option': 'OGG', 'title': 'OGG' },
      { 'option': 'PCM', 'title': 'PCM' },
      { 'option': 'AC3', 'title': 'AC3' },
      { 'option': 'MIDI', 'title': 'MIDI' },
      { 'option': 'MP3', 'title': 'MP3' },
      { 'option': 'AAC', 'title': 'AAC' },
      { 'option': 'GIF', 'title': 'GIF' },
      { 'option': 'BMP', 'title': 'BMP' },
      { 'option': 'PNG', 'title': 'PNG' },
      { 'option': 'PDF', 'title': 'PDF' },
      { 'option': 'DOC', 'title': 'DOC' },
      { 'option': 'XLS', 'title': 'XLS' }
    ]
  },
  {
    'field_map': 'filesize',
    'item_name': 'file_size',
    'title': 'File size',
    'hint_detail': 'File size of digital asset as measured in Kilobytes (kb).',
    'hint_panel' : 'File size of digital asset as measured in Kilobytes (kb).',
    'example': '',
    'sequence': 17,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'thirdPartyAsset',
    'item_name': 'third_party_asset',
    'title': 'Asset Hosted Externally',
    'hint_detail': 'Asset Hosted Externally.',
    'hint_panel' : 'Asset Hosted Externally.',
    'example': '',
    'sequence': 18,
    'show_more': true,
    'lookup': [
      {
        'option': 0,
        'title': 'No'
      },
      {
        'option': 1,
        'title': 'Yes'
      }
    ]
  },
  {
    'field_map': 'fileDateModified',
    'item_name': 'file_date_modified',
    'title': 'Modified date',
    'hint_detail': 'Modified date of this digital asset.',
    'hint_panel' : 'Modified date of this digital asset.',
    'example': '',
    'sequence': 19,
    'show_more': true,
    'lookup': null,
    'type': DetailsControlType.Date,
  },

  {
    'field_map': 'frame',
    'item_name': 'frame',
    'title': 'Frame',
    'hint_detail': 'Number of the image frame',
    'hint_panel' : 'Number of the image frame',
    'example': '',
    'sequence': 30,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'totalFrame',
    'item_name': 'total_frame',
    'title': 'Total Frame',
    'hint_detail': 'Total number of frames within a plane',
    'hint_panel' : 'Total number of frames within a plane',
    'example': '',
    'sequence': 31,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'hemisphere',
    'item_name': 'hemisphere',
    'title': 'Hemisphere',
    'hint_detail': 'Either Northern (N) or Southern (S)',
    'hint_panel' : 'Either Northern (N) or Southern (S)',
    'example': '',
    'sequence': 32,
    'show_more': true,
    'lookup': [
      {
        'option': 'N',
        'title': 'North'
      },
      {
        'option': 'S',
        'title': 'South'
      }
    ]
  },
  {
    'field_map': 'plunge',
    'item_name': 'plunge',
    'title': 'Plunge',
    'hint_detail': 'Plunge angle when photographed',
    'hint_panel' : 'Plunge angle when photographed',
    'example': '',
    'sequence': 33,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'plane',
    'item_name': 'plane',
    'title': 'Plane',
    'hint_detail': 'Number of planes that are in the 3D image set',
    'hint_panel' : 'Number of planes that are in the 3D image set',
    'example': '',
    'sequence': 34,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'totalPlanes',
    'item_name': 'total_planes',
    'title': 'Total Planes',
    'hint_detail': 'Number of planes for a 360 degree image',
    'hint_panel' : 'Number of planes for a 360 degree image',
    'example': '',
    'sequence': 35,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'duration',
    'item_name': 'duration',
    'title': 'Duration',
    'hint_detail': 'Video Duration',
    'hint_panel' : 'Video Duration',
    'example': '',
    'sequence': 36,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'durationUom',
    'item_name': 'duration_uom',
    'title': 'Duration UOM',
    'hint_detail': 'Duration unit of measurement',
    'hint_panel' : 'Duration unit of measurement',
    'example': '',
    'sequence': 37,
    'show_more': true,
    'lookup': [
      {
        'option': 'hh',
        'title': 'Hours'
      },
      {
        'option': 'mm',
        'title': 'Minutes'
      },
      {
        'option': 'ss',
        'title': 'Seconds'
      }
    ]
  },
  {
    'field_map': 'descriptions',
    'item_name': 'descriptions',
    // "type": "list",
    'title': '',
    'hint_detail': '',
    'hint_panel' : '',
    'example': {},
    'sequence': 38,
    'show_more': true,
    'lookup': null
  },
];
/* eslint-enable */
